import { validate } from 'class-validator'
import { GetDocumentsDTO } from '../../dto'
import { store } from '../../store'
import { createCall } from '../base'
import { BASE_METHODS } from '../base/base.constants'
import { plainToClass } from 'class-transformer'
import { GET_DOCUMENTS_ACTIONS } from './get-documents.constants'

const getFallbackLanguage = (language: string) => {
    if (language === 'al') {
        return 'en'
    }

    return null
}

export const getDocuments = async (type: number, language: string) => {
    store.dispatch({ type: GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_STARTED })

    const fetchDocuments = async (requestedLanguage: string) => {
        const response = await createCall(`microsite/documents/?type=${type}&language=${requestedLanguage}`, BASE_METHODS.GET)
        let responseBody: GetDocumentsDTO

        try {
            responseBody = plainToClass(GetDocumentsDTO, JSON.parse(await response.text()))
        } catch (error) {
            throw new Error(GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_INVALID_JSON)
        }

        if ((await validate(responseBody)).length > 0) {
            throw new Error(GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_INVALID_RESPONSE)
        }

        return responseBody.documents
    }

    try {
        const documents = await fetchDocuments(language)
        store.dispatch({ type: GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_OK, documents })
    } catch (error) {
        const fallbackLanguage = getFallbackLanguage(language)

        if (fallbackLanguage !== null) {
            try {
                const documents = await fetchDocuments(fallbackLanguage)
                store.dispatch({ type: GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_OK, documents })
                return
            } catch (fallbackError) {
                console.log(fallbackError)
            }
        }

        console.log(error)

        if (error instanceof Error && error.message === GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_INVALID_JSON) {
            store.dispatch({ type: GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_INVALID_JSON })
            return
        }

        if (error instanceof Error && error.message === GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_INVALID_RESPONSE) {
            store.dispatch({ type: GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_INVALID_RESPONSE })
            return
        }

        store.dispatch({ type: GET_DOCUMENTS_ACTIONS.GET_DOCUMENTS_ERROR })
    }
}
